<template>
  <footer class="footer bg-dark text-white pt-5 pb-4">
    <div class="container text-center text-md-start">
      <div class="row">
        <!-- Column 1: Name and description -->
        <div class="col-md-4 col-lg-4 col-xl-4 mx-auto mb-4">
          <h6 class="text-uppercase fw-bold">Micro-crèche Bébé Bulle</h6>
          <hr class="mb-4 mt-0 d-inline-block mx-auto" style="width: 60px; background-color: #0d6efd; height: 2px" />
          <p>
            Un lieu d'accueil chaleureux et sécurisant pour l'épanouissement des tout-petits à Soues.
          </p>
        </div>

        <!-- Column 2: Quick navigation links -->
        <div class="col-md-4 col-lg-2 col-xl-2 mx-auto mb-4">
          <h6 class="text-uppercase fw-bold">Navigation</h6>
          <hr class="mb-4 mt-0 d-inline-block mx-auto" style="width: 60px; background-color: #0d6efd; height: 2px" />
          <p><a href="#qui-sommes-nous" class="text-white-50">L'équipe</a></p>
          <p><a href="#ou-sommes-nous" class="text-white-50">Nous trouver</a></p>
          <p><a href="#formulaire" class="text-white-50">Pré-inscription</a></p>
        </div>

        <!-- Column 3: Contact (MODIFIED) -->
        <div class="col-md-4 col-lg-4 col-xl-4 mx-auto mb-md-0 mb-4">
          <h6 class="text-uppercase fw-bold">Contact</h6>
          <hr class="mb-4 mt-0 d-inline-block mx-auto" style="width: 60px; background-color: #0d6efd; height: 2px" />

          <!-- Using Flexbox for perfect alignment -->
          <div class="d-flex justify-content-center justify-content-md-start align-items-center mb-2">
            <i class="bi bi-geo-alt-fill me-3 flex-shrink-0"></i>
            <span>3 bis rue G. Nerisson, 65430 Soues</span>
          </div>
          <div class="d-flex justify-content-center justify-content-md-start align-items-center mb-2">
            <i class="bi bi-telephone-fill me-3 flex-shrink-0"></i>
            <span>05 62 94 84 85</span>
          </div>
          <a
            href="https://www.facebook.com/Micro-cr%C3%A8che-B%C3%A9b%C3%A9-bulle-101714458750934/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-white-50 d-flex justify-content-center justify-content-md-start align-items-center"
          >
            <i class="bi bi-facebook me-3 flex-shrink-0"></i>
            <span>Suivez-nous sur Facebook</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="text-center p-3 mt-4" style="background-color: rgba(0, 0, 0, 0.2)">
      © {{ new Date().getFullYear() }} Copyright:
      <a class="text-white fw-bold" href="#">Micro-crèche Bébé Bulle</a>
<!--     |  <a href="#" @click.prevent="$emit('show-legal')" class="text-white-50">Mentions Légales</a>-->
    </div>
  </footer>
</template>

<script setup lang="ts">
// No script needed. The year is calculated directly in the template.
</script>

<style scoped>
.footer a {
  text-decoration: none;
  transition: color 0.2s ease-in-out;
}

.footer a:hover {
  color: #fff !important; /* Make the link white on hover */
  text-decoration: underline;
}
</style>
